import React from 'react';
import { Helmet } from 'react-helmet';
import CssBaseline from '@material-ui/core/CssBaseline';
import styled, { ThemeProvider } from 'styled-components';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { useScrollTrigger, Zoom, Fab } from '@material-ui/core';
import PropTypes from 'prop-types';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Header from './header';
import Hero from '../sections/hero';
import Footer from './footer';
import customTheme from '../../theme';

const Main = styled.main`
  overflow: hidden;
  background: white;
`;

const Div = styled.div`
  position: fixed;
  bottom: 5%;
  right: 5%;
`;

function ScrollTop({ children }) {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = () => {
    const anchor = document.querySelector('#gatsby-focus-wrapper');

    if (anchor) {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <Zoom in={trigger}>
      <Div onClick={handleClick} role="presentation">
        {children}
      </Div>
    </Zoom>
  );
}
const Layout = ({
  heroButton,
  heroHeading,
  heroMessage,
  heroImage,
  heroLogo,
  scrollLogo,
  children,
}) => (
  <React.Fragment>
    <Helmet>
      <meta charSet="utf-8" />
      <title>Dayna's Pet Sitting</title>
      <meta
        name="description"
        content="Providing Peace of Mind for you and Your Pets"
      />
      <link rel="canonical" href="https://www.daynaspetsitting.com/" />
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css?family=Pacifico&family=Roboto:300,400,500,700&display=swap"
      />
    </Helmet>
    <CssBaseline />
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <MuiThemeProvider theme={customTheme}>
        <ThemeProvider theme={customTheme}>
          <Header scrollLogo={scrollLogo} id="back-to-top-anchor" />
          <Main>
            <Hero
              heroButton={heroButton}
              heroHeading={heroHeading}
              heroMessage={heroMessage}
              heroImage={heroImage}
              heroLogo={heroLogo}
            />
            {children}
          </Main>
          <Footer />
        </ThemeProvider>
      </MuiThemeProvider>
    </MuiPickersUtilsProvider>
    <ScrollTop>
      <Fab size="small" aria-label="scroll back to top" color="primary">
        <KeyboardArrowUpIcon />
      </Fab>
    </ScrollTop>
  </React.Fragment>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
